<template>
    <div class="relative py-4">
        <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-300"></div>
        </div>
        <div class="relative flex justify-center">
            <span class="bg-white text-sm text-gray-500 dark:bg-gray-700 dark:text-gray-400"
                :class="{'px-4': props.orientation === 'horizontal', 
                    'py-2': props.orientation === 'vertical'}">
                <slot></slot>
            </span>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    orientation: {
        type: String,
        default: 'horizontal'
    }
});
</script>